<template>
  <TrainingReport v-if="userHasPermission" :useClientLayout="true" />
  <AdminLayout v-else page="Training Report" title="Training Report">
    You need permission to view this page.
  </AdminLayout>
</template>
<script lang="ts" setup>
import TrainingReport from "../staffadmin/TrainingReport.vue";
import { PermissionType } from "../../store/generatedFetchClient";
import { useUserStore } from "../../store/userStore";

var userHasPermission = computed(() =>
  useUserStore().hasPermission(PermissionType.ViewTrainingReport)
);
</script>
